import React, { Component } from 'react'
import anime from 'animejs'
import SectionHeading from 'components/SectionHeading'
import { Text, Flex, Box } from 'rebass/styled-components'
import Tagline from 'components/Tagline'
import { Waypoint } from 'react-waypoint'
import { ACCENT1_COLOR, GRAY2_COLOR } from '../services/constants'
const processText = {
  Identify: `We'll start anywhere on your roadmap. 
  Share your vision and your challenges, 
  and we'll quickly identify how we can add value.`,
  Organize: `Your problems are unique, so we'll specifically 
  form a team tailored to solving them. A team drawn exclusively 
  from those who want to be a part your opportunity.`,
  Make: `The right team, guided by your mission, delivering 
  custom solutions. We understand that requirements can change 
  and guarantee highly responsive communication.`,
  Enhance: `Launch is never the final destination. It's time 
  to disrupt your own product before others do. Only now, 
  you're armed with actual user data to power your decisions.`,
}
const approachIntro = `Our approach`
const approachOutro = `
Proven, refined, and ready to align with your vision.
`
let animation
const BOUNDS = 500
const animateIn = (el) => {
  const LINE_DURATION = 1000
  const MASTER_OFFSET = 250
  animation = anime.timeline()
  animation
    .add({
      targets: el.circleStart,
      opacity: 1,
      r: 2,
      duration: 0,
    })
    .add({
      targets: el.segmentL,
      opacity: 1,
      strokeDashoffset: [anime.setDashoffset, 0],
      duration: LINE_DURATION,
      easing: 'easeInOutSine',
      delay: MASTER_OFFSET,
    })
    .add({
      targets: el.arrow,
      opacity: 1,
      translateX: 492,
      duration: LINE_DURATION,
      easing: 'easeInOutSine',
      offset: MASTER_OFFSET,
    })
    .add({
      targets: [el.circle0, el.circle1, el.circle2, el.circle3],
      r: 10,
      strokeWidth: 1,
      opacity: 1,
      delay: (el, i, l) => {
        return i * 250
      },
    })
    .add({
      targets: '.process-text',
      opacity: [0, 1],
      translateY: [-50, 0],
      easing: 'easeOutQuint',
      offset: '-=1500',
      delay: (el, i, l) => {
        return i * 250
      },
    })

  animation.finished.then(() => {
    anime({
      targets: [el.circle0, el.circle1, el.circle2, el.circle3],
      before: (el) => {
        el.style.transformOrigin = '50%'
      },
      rotateX: 180,
      loop: true,
      easing: 'easeInOutQuad',
      duration: 1000,
      delay: (el, i, l) => {
        return i * 250 + 5000
      },
    })
  })
}

const pathStyle = {
  stroke: ACCENT1_COLOR,
  fill: ACCENT1_COLOR,
  opacity: 0,
}

const circleStyle = {
  r: '0',
  fill: 'none',
  stroke: ACCENT1_COLOR,
}

const endCircleStyle = {
  r: '0',
  fill: ACCENT1_COLOR,
}

const svgProps = {
  viewBox: `0 0 ${BOUNDS} ${BOUNDS / 5}`,
  width: '100%',
  height: '100%',
  preserveAspectRatio: 'xMidYMid',
  overflow: 'visible',
}

class Process extends Component {
  state = {
    mounted: false,
  }
  handleEnter = () => {
    if (!this.state.mounted) {
      animateIn(this)
    }

    this.setState({ mounted: true })
  }

  render () {
    return (
      <Flex flexDirection='column' p={4}>
        <Waypoint onEnter={this.handleEnter} bottomOffset='50px' />
        <Box>
          <SectionHeading white fontSize={5} textAlign='center'>
            {approachIntro}
          </SectionHeading>
          <Tagline textAlign='center' color={GRAY2_COLOR}>
            {approachOutro}
          </Tagline>
        </Box>
        <Box>
          <svg
            {...svgProps}
            ref={(c) => {
              this.timeline = c
            }}
          >
            <g
              ref={(c) => {
                this.svgGroup = c
              }}
            >
              {/* TODO: transform origin on path */}
              <path
                d='M0 50 H 500'
                {...pathStyle}
                ref={(c) => {
                  this.segmentL = c
                }}
              />
              <circle
                cx='0%'
                cy='50%'
                ref={(c) => {
                  this.circleStart = c
                }}
                {...endCircleStyle}
              />
              <path
                d='M0 48 L 8 50 L 0 52'
                {...pathStyle}
                ref={(c) => {
                  this.arrow = c
                }}
              />
              <circle
                cx='12.5%'
                cy='50%'
                ref={(c) => {
                  this.circle0 = c
                }}
                {...circleStyle}
              />
              <circle
                cx='37.5%'
                cy='50%'
                ref={(c) => {
                  this.circle1 = c
                }}
                {...circleStyle}
              />
              <circle
                cx='62.5%'
                cy='50%'
                ref={(c) => {
                  this.circle2 = c
                }}
                {...circleStyle}
              />
              <circle
                cx='87.5%'
                cy='50%'
                ref={(c) => {
                  this.circle3 = c
                }}
                {...circleStyle}
              />
            </g>
          </svg>
        </Box>
        <Box>
          <Flex mx={-2} flexWrap='wrap'>
            {Object.keys(processText).map((item, index) => (
              <Box
                key={`process-${item}`}
                className='process-text'
                width={[1, 1 / 4]}
                p={2}
              >
                <SectionHeading white fontSize={3}>
                  {item}
                </SectionHeading>
                <Text color={GRAY2_COLOR}>{processText[item]}</Text>
              </Box>
            ))}
          </Flex>
        </Box>
      </Flex>
    )
  }
}

export default Process
